<script>
import { mapState } from "pinia";
import {
  CommentsWidgetElementMixin,
} from "%/dynamic-component-editor/standard-elements/comments-widget/comments-widget-element-mixin";
import ButtonOptions from "%/dynamic-component-editor/bundles/button-options";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import {
  SharedButtonComputedStylesMixin,
} from "%/dynamic-component-editor/standard-elements/button-element/shared-button-computed-styles-mixin";

export default {
  name: "AddCommentButton",
  extends: BaseButtonElement,
  mixins: [CommentsWidgetElementMixin],
  elementPanelSettings: {
    displayName: "Add Comment",
    displayIcon: "button",
    elementGroup: "commentWidgetElements",
    elementType: "element",
  },
  optionBundles: [
    new ButtonOptions({
      "default.text-option": "Add A Comment",
      "default.icon": "",
    }, {
      "button-action": true,
      "link-type": true,
      "href-option": true,
    }),
  ],
  computed: {
    ...mapState(useConfigurationStore, ["canCommentOnPosts"]),
    shouldRenderButton() {
      return this.editMode || this.canCommentOnPosts;
    },
    buttonStyleOverrides() {
      return {
        ...SharedButtonComputedStylesMixin.computed.buttonStyleOverrides.call(this),
        contentGap: "small",
      };
    },
  },
  methods: {
    handleButtonClick() {
      if (!this.showsSampleComments) {
        this.storyComments.openCommentInputOnPage(this.storyEntityId);
      }
    },
  },
};
</script>
